import { useTranslation } from "react-i18next";

import { SectionContentProps } from "./SectionNextActions.decl.ts";

import { Section, SectionHeader, SectionTitle } from "@/blocks/Section";
import { useCall } from "@/hooks/useCall/useCall";

function SectionContent({ items }: SectionContentProps) {
  const { t } = useTranslation();

  // When the call was not processed
  if (!items) {
    return (
      <p
        className="text-sm font-normal text-muted-foreground"
        data-test="no-actions-generated"
      >
        {t("call_context.no_actions_generated")}
      </p>
    );
  }

  // When the call was processed and no actions
  if (!items.length) {
    return (
      <p className="text-sm font-normal text-muted-foreground">
        {t("call_context.no_actions")}
      </p>
    );
  }

  return (
    <ul className="m-0 list-outside list-disc pl-5">
      {items.map((item) => (
        <li key={item.ID} className="text-base font-medium">
          {item.content}
        </li>
      ))}
    </ul>
  );
}

export function SectionNextActions() {
  const { t } = useTranslation();
  const { call } = useCall();

  if (!call) {
    return null;
  }

  return (
    <Section data-test="next-actions-section">
      <SectionHeader>
        <SectionTitle>{t("call_context.action_items")}</SectionTitle>
      </SectionHeader>
      <SectionContent items={call.nextActions} />
    </Section>
  );
}
